var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"no-data-wrap"},[_c('Icon',{staticClass:"no-data-icon",attrs:{"type":"no-data","size":_vm.size,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }